// removed by extract-text-webpack-plugin
module.exports = {"listWrapper":"BnqLr4taBdGtMomc-fIGr","title":"_24YH_bbE-Qb2aXv3FjGkm5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FAQList/FaqList.scss
// module id = 1601
// module chunks = 0